module.exports = __webpack_public_path__ + "static/media/13-kjole.3f387fe3.mp3";